/* eslint-disable class-methods-use-this */
/* eslint-disable id-length */
/* eslint-disable no-inline-comments */
// @flow
import React from 'react';
import { Modal } from '@finect/tabular-components/Modal';
import { Button } from '@finect/tabular-core/Button';
import { X } from '@finect/tabular-icons/x';
import { ModalBlock, ModalDropZone, RemoveImage } from './partials';

type Props = {
  show: boolean,
  onCloseModal: Function,
  onUploadImage: Function,
  isError: boolean
};

type State = {
  value: any
};

export class UploadImageModal extends React.Component<Props, State> {
  state = {
    value: null
  };

  handleDragEnter = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };
  handleDragLeave = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };
  handleDragOver = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };
  handleDrop = (e: any) => {
    const file = e.dataTransfer.files[0];
    this.setState({ value: file });
    e.preventDefault();
    e.stopPropagation();
  };
  handleOnChange = (e: any) => {
    const file = e.target.files[0];
    this.setState({ value: file });
    e.preventDefault();
    e.stopPropagation();
  };

  handleSubmit = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onUploadImage(this.state.value);
    this.setState({ value: null });
  };

  handleRemoveImage = () => {
    this.setState({ value: null });
  };

  render() {
    const { show, onCloseModal, isError } = this.props;
    const { value } = this.state;

    return (
      <Modal show={show} onClose={onCloseModal}>
        <ModalBlock>
          {isError ? <p>Ha ocurrido un error al adjuntar su imagen, intentelo nuevamente</p> : null}
          <ModalDropZone
            onDrop={(e) => {
              this.handleDrop(e);
            }}
            onDragOver={(e) => {
              this.handleDragOver(e);
            }}
            onDragEnter={(e) => {
              this.handleDragEnter(e);
            }}
            onDragLeave={(e) => {
              this.handleDragLeave(e);
            }}
          >
            <label>
              <p>{value ? value.name : 'Selecciona o arrastra una imagen'}</p>
              <input
                style={{ display: 'none' }}
                accept="image/png,image/jpg,image/jpeg"
                type="file"
                onChange={(e) => {
                  this.handleOnChange(e);
                }}
              />
            </label>
            {value ? (
              <RemoveImage onClick={this.handleRemoveImage}>
                <X />
              </RemoveImage>
            ) : null}
          </ModalDropZone>
          <div>
            <Button
              width="auto"
              disabled={!value}
              onClick={(e) => {
                this.handleSubmit(e);
              }}
            >
              Adjuntar imagen
            </Button>
          </div>
        </ModalBlock>
      </Modal>
    );
  }
}
